import {pick, keys} from 'underscore'
import WEventsMixin from '../w-events-mixin'

const PROPS = {
    /**
     * Route object.  This will be displayed bottom left if set
     */
    alternativeRoute: {
        type: Object,
        default: () => ({})
    },
    /**
     * Text to display for the alternative route
     */
    alternativeRouteText: {
        type: String,
        default: ''
    },
    /**
     * Set to true to remove padding
     */
    dense: {
        type: Boolean,
        default: false
    },
    /**
     * Hide the primary button
     */
    hidePrimaryButton: {
        type: Boolean,
        default: false
    },
    /**
     * Hide the secondary button
     */
    hideSecondaryButton: {
        type: Boolean,
        default: false
    },
    /**
     * Set the forms' loading state
     */
    loading: {
        type: Boolean,
        default: false
    },
    /**
     * The event triggered by the primary button
     */
    primaryButtonEvent: {
        type: String,
        default: 'submit'
    },
    /**
     * The text displayed on the primary button
     */
    primaryButtonText: {
        type: String,
        default: 'Submit'
    },
    /**
     * The color of the primary button
     */
    primaryButtonColor: {
        type: String,
        default: 'primary'
    },
    /**
     * Disable the primary button
     */
    primaryButtonDisabled: {
        type: Boolean,
        default: false
    },
    /**
     * The event triggered by the secondary button
     */
    secondaryButtonEvent: {
        type: String,
        default: 'close'
    },
    /**
     * The text displayed on the secondary button
     */
    secondaryButtonText: {
        type: String,
        default: 'Close'
    },
    /**
     * The color of the secondary button
     */
    secondaryButtonColor: {
        type: String,
        default: 'secondary'
    },
    /**
     * Disable the secondary button
     */
    secondaryButtonDisabled: {
        type: Boolean,
        default: false
    }
}

/**
 * @mixin
 */
export default {
    mixins: [WEventsMixin],
    props: PROPS,
    computed: {
        wCardFormActionsProps () {
            const vm = this
            const propKeys = keys(PROPS)

            return pick(vm, propKeys)
        },
        wCardFormActionsEvents () {
            const vm = this
            return {
                [vm.primaryButtonEvent]: vm.handlePrimaryButtonClick,
                [vm.secondaryButtonEvent]: vm.handleSecondaryButtonClick
            }
        }
    },
    methods: {
        handlePrimaryButtonClick () {
            /**
             * Emit primary button event event
             * @event this.primaryButtonEvent
             */
            this.$emit(this.primaryButtonEvent)
        },
        handleSecondaryButtonClick () {
            /**
             * Emit secondary button event
             * @event this.secondaryButtonEvent
             */
            this.$emit(this.secondaryButtonEvent)
        }
    }
}
